import React from "react"
import { graphql } from "gatsby"

import "./_style.scss"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Functions
import { isEmpty } from "lodash"
import HeaderContent from "§/src/components/atoms/content/header-content"

// Components
const HeroText = React.lazy(() => import("§/src/components/sections/hero-text"))
const Note = React.lazy(() => import("§/src/components/sections/editorial-content/note"))

// Language
import { useTranslation } from 'react-i18next';
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="application-other"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations} langReplace='applications'/>
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const Post = props => {

  const { t } = useTranslation()
  const notes = props?.data?.applicationNotes?.nodes

  return (
    <Layout lang={props?.data?.lang?.translations} langReplace='applications'>
      <Breadcrumb wpseo={props?.pageContext?.seo?.breadcrumbs} base={t('Settori industriali')} />

      {!isEmpty(props) ? (
        <React.Suspense fallback={<LoadingFrame/>}>
          <HeroText pretitle={t('Le applicazioni')} title={props?.pageContext?.title} />
          {notes &&
            notes?.map((note, index) => (
              <Note key={"note-" + index} note={note} />
            ))}
        </React.Suspense>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default Post

// Get all the posts.
export const pageQuery = graphql`
  query GET_CASE_HISTORIES($eq: String!) {
    applicationNotes: allWpApplication(
      filter: {
        template: { templateName: { eq: "Application Notes" } }
        wpParent: { node: { slug: { eq: $eq } } }
      }
    ) {
      nodes {
        title
        uri
        featuredImage {
          node {
            gatsbyImage(width: 500, height: 480, layout: CONSTRAINED)
          }
        }
        cptApplicationChildrens {
          subtitle
        }
      }
    }

    lang : wpApplication(slug: {eq: $eq}) {
      translations {
        postUrl
        siteId
      }
    }
  }
`
